import { Radio } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import React from "react";

const PhoneMethodRadio: React.FC<{
  checked: boolean;
  title: string;
  onChange: () => void;
}> = ({ checked, title, onChange }) => (
  <label className="flex cursor-pointer items-center gap-1 font-secondary">
    <Radio
      isChecked={checked}
      onChange={onChange}
      className="checked:bg-[#3366FF] checked:hover:bg-[#3366FF] checked:focus:bg-[#3366FF]"
    />
    <span
      className={cx(
        "text-sm leading-[130%] text-grey-700",
        checked && "text-primary-800"
      )}
    >
      {title}
    </span>
  </label>
);

export default PhoneMethodRadio;
